// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiBox-root{
}
.link{
    cursor: pointer;
}
.Emitida {
    width: 10px;
    height: 10px;
    background-color: #46c51a;
    border-radius: 50%;
    display: inline-block;
    margin-top: 6px;
  }

.Activa {
    width: 10px;
    height: 10px;
    background-color: #46c51a;
    border-radius: 50%;
    display: inline-block;
    margin-top: 6px;
}

  .Cotizada{
    width: 10px;
    height: 10px;
    background-color: #4dc5f0;
    border-radius: 50%;
    display: inline-block;
    margin-top: 6px;
  }
  .Cancelada{
    width: 10px;
    height: 10px;
    background-color: #ef2f24;
    border-radius: 50%;
    display: inline-block;
    margin-top: 6px;
  }
  .Pendiente{
    width: 10px;
    height: 10px;
    background-color: #efd718;
    border-radius: 50%;
    display: inline-block;
    margin-top: 6px;
  }
  .Expirada{
    width: 10px;
    height: 10px;
    background-color: #f0972b;
    border-radius: 50%;
    display: inline-block;
    margin-top: 6px;
  }
`, "",{"version":3,"sources":["webpack://./src/salesCore/insurancePoliciesSummary/style/insurancePoliciesSummary.css"],"names":[],"mappings":"AAAA;AACA;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;EACjB;;AAEF;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;AACnB;;EAEE;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;EACjB","sourcesContent":[".MuiBox-root{\n}\n.link{\n    cursor: pointer;\n}\n.Emitida {\n    width: 10px;\n    height: 10px;\n    background-color: #46c51a;\n    border-radius: 50%;\n    display: inline-block;\n    margin-top: 6px;\n  }\n\n.Activa {\n    width: 10px;\n    height: 10px;\n    background-color: #46c51a;\n    border-radius: 50%;\n    display: inline-block;\n    margin-top: 6px;\n}\n\n  .Cotizada{\n    width: 10px;\n    height: 10px;\n    background-color: #4dc5f0;\n    border-radius: 50%;\n    display: inline-block;\n    margin-top: 6px;\n  }\n  .Cancelada{\n    width: 10px;\n    height: 10px;\n    background-color: #ef2f24;\n    border-radius: 50%;\n    display: inline-block;\n    margin-top: 6px;\n  }\n  .Pendiente{\n    width: 10px;\n    height: 10px;\n    background-color: #efd718;\n    border-radius: 50%;\n    display: inline-block;\n    margin-top: 6px;\n  }\n  .Expirada{\n    width: 10px;\n    height: 10px;\n    background-color: #f0972b;\n    border-radius: 50%;\n    display: inline-block;\n    margin-top: 6px;\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
